import { tickerItems } from "@/content/siteContent";

export default function Ticker() {
  const items = [...tickerItems, ...tickerItems];
  return (
    <div className="overflow-hidden border-y border-metal bg-graphite py-4" data-testid="specialties-ticker">
      <div className="marquee-track flex w-max items-center gap-8">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-8">
            <span className="whitespace-nowrap font-display text-xs font-bold tracking-[0.24em] text-mist">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-brand" />
          </span>
        ))}
      </div>
    </div>
  );
}
